import { render, staticRenderFns } from "./recommend_mini.vue?vue&type=template&id=29d51eaa&scoped=true&"
import script from "./recommend_mini.vue?vue&type=script&lang=js&"
export * from "./recommend_mini.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d51eaa",
  null
  
)

export default component.exports